<template>
    <div>
        <div class="file-table-container">
            <table style="width:100%">
                <tr v-for="(eventAttachment, index) in model.attach_file_list" :key="index">
                    <td style="width:10%;">
                        <FileView :resource="eventAttachment" @click="onViewFile(index)" />
                    </td>
                    <td style="width:70%;" class="mt-2 filename-cell"
                        :class="{ 'text-red': eventAttachment.invalid_file }">
                        <span :title="eventAttachment.name">{{ eventAttachment.name }}</span>
                    </td>
                    <td style="width:20%; text-align: center;">
                        <button @click.prevent="onDownloadFile(eventAttachment, index)" class="download-btn-icon"
                            :disabled="eventAttachment.downloading" :title="$t('Download')">
                            <i v-if="!eventAttachment.downloading" class="fas fa-download"></i>
                            <i v-else class="fas fa-spinner fa-spin"></i>
                        </button>
                    </td>
                </tr>
            </table>
        </div>

        <a-modal v-model="showModalFileView" :zIndex="1020" width="40%" :title="$t('eventManagement.viewAttachment')"
            :footer="null" :maskClosable="false">
            <div class="ts-rounded-md group ts-relative ts-text-center ts-justify-between ts-items-center"
                style="height: 70vh;">
                <button @click.prevent="onMoveBack"
                    class="hover:ts-bg-gray-400 ts-absolute ts-left-0 ts-ml-3 ts-bg-gray-300 ts-px-4 ts-py-2 ts-rounded-md">
                    <i class="fas fa-chevron-left ts-text-gray-700"></i>
                </button>
                <button @click.prevent="onMoveNext"
                    class="hover:ts-bg-gray-400 ts-absolute ts-right-0 ts-mr-3 ts-bg-gray-300 ts-px-4 ts-py-2 ts-rounded-md">
                    <i class="fas fa-chevron-right ts-text-gray-700"></i>
                </button>
                <ViewModal :fileResource="currentViewFileResource" />
            </div>
        </a-modal>
    </div>
</template>


<script>
import FileView from './file-viewer.vue'
import ViewModal from './view-modal.vue'
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'

export default {
    name: 'attachFileShow',
    components: { FileView, ViewModal },
    props: ['value', 'editData'],
    data() {
        return {
            showModalFileView: false,
            currentViewIndex: 0,
            model: {
                attach_file_list: []
            }
        }
    },
    created() {
        if (this.value && Array.isArray(this.value.event_attachments)) {
            this.model.attach_file_list = this.value.event_attachments.map(el => ({
                event_att_id: el.event_att_id,
                name: el.attach_file_name,
                type: el.attach_file_mime_type,
                progressing: 100,
                invalid_file: false,
                file: el.attach_file_path,
                attach_file_path: el.attach_file_path,
                uploaded: true,
                storage_path: el.storage_path,
                downloading: false
            }))
        }
    },
    computed: {
        currentViewFileResource() {
            return this.model.attach_file_list[this.currentViewIndex] || null
        }
    },
    methods: {
        ...mapActions('eventManagement', ['removeFileUploaded']),

        onRemoveFile(index, record) {
            if (record.event_att_id > 0) {
                this.removeFileUploaded({
                    event_att_id: record.event_att_id,
                    attach_file_path: record.attach_file_path
                })
            }
            this.model.attach_file_list.splice(index, 1)
        },

        onViewFile(index) {
            this.showModalFileView = true
            this.currentViewIndex = index
        },

        onMoveBack() {
            this.currentViewIndex =
                this.currentViewIndex - 1 >= 0
                    ? this.currentViewIndex - 1
                    : this.model.attach_file_list.length - 1
        },

        onMoveNext() {
            this.currentViewIndex =
                this.currentViewIndex + 1 < this.model.attach_file_list.length
                    ? this.currentViewIndex + 1
                    : 0
        },



        onDownloadFile(eventAttachment, index) {
            this.$set(this.model.attach_file_list[index], 'downloading', true);

            FileDownload(eventAttachment.storage_path);

            setTimeout(() => {
                this.$set(this.model.attach_file_list[index], 'downloading', false);
            }, 1000);
        }
    }

}
</script>

<style scoped>
.file-table-container {
    overflow-x: auto;
}

.file-table-container table {
    table-layout: fixed;
}

.filename-cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 0;
}

.filename-cell span {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.download-btn-icon {
    width: 30px;
    height: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #1890ff;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
}

.download-btn-icon:hover:not(:disabled) {
    background: #40a9ff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.5);
}

.download-btn-icon:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(24, 144, 255, 0.4);
}

.download-btn-icon:disabled {
    background: #91d5ff;
    cursor: not-allowed;
    box-shadow: none;
}

.download-btn-icon i {
    font-size: 14px;
}

.fa-spin {
    animation: fa-spin 1s infinite linear;
}

@keyframes fa-spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>